import { ConfigService } from 'src/app/shared/services/config/config.service';
import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';

export function initCulture(configService: ConfigService, localStorageService: LocalStorageService): void {
  let culture = localStorageService.getCulture();
  if (!culture) {
    culture = configService.getProperty<string>('DEFAULT_CULTURE');
    localStorageService.setCulture(culture);
  }
}
